import { CreateAPI } from 'services/utils/CreateAPI';
import { retryAndSetAuth, setAuthHeader } from 'services/utils/interceptors';

export const adminAPI = new CreateAPI({
  apiName: 'admin',
  requestInterceptors: [setAuthHeader],
  errorInterceptors: [retryAndSetAuth],
});

export const unitAPI = new CreateAPI({
  apiName: 'admin',
  apiPath: '/admin/units',
  requestInterceptors: [setAuthHeader],
  errorInterceptors: [retryAndSetAuth],
});

export const federatedUnitAPI = new CreateAPI({
  apiName: 'admin',
  apiPath: '/admin/ufs',
  requestInterceptors: [setAuthHeader],
  errorInterceptors: [retryAndSetAuth],
});

export const usersAPI = new CreateAPI({
  apiName: 'admin',
  apiPath: '/admin/users',
  requestInterceptors: [setAuthHeader],
  errorInterceptors: [retryAndSetAuth],
});

export const channelAPI = new CreateAPI({
  apiName: 'admin',
  apiPath: '/admin/channels',
  requestInterceptors: [setAuthHeader],
  errorInterceptors: [retryAndSetAuth],
});

export const personalityAPI = new CreateAPI({
  apiName: 'admin',
  apiPath: '/admin/personalities',
  requestInterceptors: [setAuthHeader],
  errorInterceptors: [retryAndSetAuth],
});

export const keywordAPI = new CreateAPI({
  apiName: 'admin',
  apiPath: '/admin/keywords',
  requestInterceptors: [setAuthHeader],
  errorInterceptors: [retryAndSetAuth],
});

export const collectionAPI = new CreateAPI({
  apiName: 'admin',
  apiPath: '/admin/collections',
  requestInterceptors: [setAuthHeader],
  errorInterceptors: [retryAndSetAuth],
});

export const seriesAPI = new CreateAPI({
  apiName: 'admin',
  apiPath: '/admin/series',
  requestInterceptors: [setAuthHeader],
  errorInterceptors: [retryAndSetAuth],
});

export const videoAPI = new CreateAPI({
  apiName: 'admin',
  apiPath: '/admin/videos',
  requestInterceptors: [setAuthHeader],
  errorInterceptors: [retryAndSetAuth],
});

export const mediaAPI = new CreateAPI({
  apiName: 'admin',
  apiPath: '/admin/media',
  requestInterceptors: [setAuthHeader],
  errorInterceptors: [retryAndSetAuth],
});
